import React, { FC } from 'react';
import { Box, Text, Radio, TextFieldSize, FormControl, Select, TextFieldAppearance } from '@bechtel/gds';
import { DrawerSubHeaderStyled } from './styled';
import { Trans } from '@lingui/macro';
import { Lang } from '../form-data';

export const DropdownSelectedItem = ({ item }: { item: any }) => {
  return (
    <Text family="graphik" size="400" color="grey.1000">
      {item.name}
    </Text>
  );
};
export const DropdownItem = ({ item }: { item: any }) => {
  return (
    <Text size="400" color="grey.1000">
      {item.name}
    </Text>
  );
};

interface DisplaySettingsProps {
  languageList: Lang[];
  userLanguage: Lang;
  setUserLanguage: (value: Lang) => void;
}

export const DisplaySettings: FC<DisplaySettingsProps> = ({ languageList, userLanguage, setUserLanguage }) => {
  return (
    <Box flexGrow={{ sm: 1 }} flexDirection={{ sm: 'column' }}>
      <DrawerSubHeaderStyled>Quantities</DrawerSubHeaderStyled>
      <Box mt={{ sm: '600' }} mb={{ sm: '400' }} mx={{ sm: '500' }}>
        <Text family="graphik" size="300" color="black">
          <Trans>Select how would you like the work package scope to display</Trans>
        </Text>
      </Box>
      <Box mx={{ sm: '500' }}>
        <Text family="graphik" size="300" color="black">
          <Trans>in your user interface</Trans>
        </Text>
      </Box>
      <Box flexDirection={{ sm: 'column' }} mx={{ sm: '500' }} my={{ sm: '550' }}>
        <Box alignItems={{ sm: 'center' }} mb={{ sm: '500' }}>
          <Box mr={{ sm: '500' }}>
            <Radio size={TextFieldSize.LARGE} readOnly checked={true} />
          </Box>
          <Text family="graphik" size="300" color="black">
            <Trans>Hours (hrs)</Trans>
          </Text>
        </Box>
        <Box alignItems={{ sm: 'center' }} mb={{ sm: '550' }}>
          <Box mr={{ sm: '500' }}>
            <Radio size={TextFieldSize.LARGE} readOnly checked={false} />
          </Box>
          <Text family="graphik" size="300" color="black">
            <Trans>Quantities (LF, LM)</Trans>
          </Text>
        </Box>
      </Box>
      <DrawerSubHeaderStyled>Language</DrawerSubHeaderStyled>
      <Box
        my={{ sm: '500' }}
        mx={{ sm: '500' }}
        flexGrow={{ sm: '1' }}
        css={`
          max-width: 352px;
        `}
      >
        <FormControl
          label="Language (Required)"
          css={`
            flex-grow: 1;
          `}
        >
          <Select
            name="language"
            size={TextFieldSize.LARGE}
            appearance={TextFieldAppearance.NORMAL}
            items={languageList}
            selectedItem={userLanguage}
            itemComponent={DropdownItem}
            selectedComponent={DropdownSelectedItem}
            onSelectedItemChange={(changes: any) => {
              setUserLanguage(changes.selectedItem);
            }}
            popperStyle={{ zIndex: 3 }}
          />
        </FormControl>
      </Box>
    </Box>
  );
};
